import { useGetFrontTipiDomandaId } from '@framework/api-client/api/inquiries-compile/tipi-domanda/tipi-domanda.ts';
import { selectTranslatedInquiryType } from '@framework/common-web/schema/translations/selectTranslatedInquiryType.ts';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useControlledAccessSubmission } from './useControlledAccessSubmission.ts';

/**
 * Hook che raccoglie tutti i dati necessari per la visualizzazione di una submission
 */
export function useSubmission(submissionId: string | null) {
  const submissionRequest = useControlledAccessSubmission(submissionId);
  const { t } = useTranslation();

  const submission = useMemo(
    () => submissionRequest.data,
    [submissionRequest.data],
  );

  // biome-ignore lint/suspicious/noNonNullAssertedOptionalChain: <tbd>
  const inquiryRequest = useGetFrontTipiDomandaId(submission?.idTipoDomanda!, {
    query: {
      keepPreviousData: true,
      enabled: Boolean(submission?.idTipoDomanda),
      select: selectTranslatedInquiryType,
    },
  });

  const inquiry = useMemo(() => inquiryRequest.data, [inquiryRequest.data]);

  const title = useMemo(
    () =>
      inquiry?.copertina?.titolo ??
      inquiry?.titolo ??
      t('submission.richiesta', 'Richiesta'),
    [inquiry?.copertina?.titolo, inquiry?.titolo, t],
  );

  return {
    submission,
    inquiry,
    title,
    submissionRequest,
    inquiryRequest,
  };
}

export type IUseSubmission = ReturnType<typeof useSubmission>;
